import Icon        from 'antd/lib/icon';
import React        from 'react';
import Slider   from 'antd/lib/slider';
import connectField from 'uniforms/connectField';
import Checkbox from 'antd/lib/checkbox';
import wrapField from './wrapField';


class Slider_ extends React.Component {
    constructor () {
        super(...arguments);
        this.onChangeOptional = this.onChangeOptional.bind(this);
        this.state = {
            na: this.props.value === null ? true : false
        }
    }

    onChangeOptional () {
        this.setState({na: !this.state.na});
        this.props.onChange(!this.state.na ? null : this.props.initialValue ? this.props.initialValue :  Math.round((this.props.max - this.props.min) / 2));
    }

    componentWillReceiveProps (props) {
      if (props.value !== null) {
          this.setState({na: false});
      }
    }

    render () {
      const {value, max, min, iconMin, iconMax, optional, onChange, initialValue } = this.props;
      let marks = {};
        marks[min-1] =  {
                        style: {
                        marginTop: 2,
                        fontSize: 10
                      },
                      label: <span>NotSet</span>
                    };
      for (let k = min; k <= max; k++) {
            marks[k] = {
                        style: {
                            marginTop: 2,
                            fontSize: 12
                        },
                        label: <strong>{k}</strong>
                    }
      }
      return wrapField(this.props, (
        <div>
          {optional &&
            <div style={{paddingLeft: 40, marginBottom: 0}}>
                <Checkbox checked={this.state.na} onChange={this.onChangeOptional} style={{fontSize: 12}}>Not Applicable</Checkbox>
            </div>
          }
          {!this.state.na &&
              <div className="anticon-wrapper">
                    <Icon className={value < (max - min) / 2 && value !== null ? 'anticon-highlight' : null} type={iconMin} />
                    <Slider
                      marks={marks}
                      max={max}
                      min={min-1}
                      onChange={(value)=>value < min ? onChange(null) : onChange(value)}
                      value={(value === undefined || value === null) ? initialValue || initialValue === 0 ? initialValue : Math.round((max - min) / 2) : value }
                    />
                    <Icon className={value > (max - min) / 2 ? 'anticon-highlight' : null} type={iconMax} />
                </div>
            }
        </div>
      ));
    }
}

Slider_.defaultProps = {
    iconMax: 'smile-o',
    iconMin: 'frown-o'
};

export default connectField(Slider_, {ensureValue: false});



// WEBPACK FOOTER //
// ./src/components/UI/uniforms/SliderField.jsx